import { get } from 'lodash';
import * as LoginApi from '@/api/login';
import { storage } from '@/utils';
import actionTypes from './actionType';
import { getCurrentEmployee } from '../user';

// const shopUserMap = {
//   '118908': 'DJ0002',
//   '117100': 'DJ0001',
//   '113592': 'DJ0003',
//   '19807': 'DJ0004',
// };

export const toggleLoading = (state) => {
  return {
    type: actionTypes.TOGGLE_LOADING,
    payload: state,
  };
};

export const userLogin = (params) => {
  return async (dispatch) => {
    dispatch(toggleLoading('loginLoading'));
    try {
      const res = await LoginApi.qrcodeLogin(params);
      if (res.code === 0) {
        const accessToken = get(res, 'data.accessToken', '');
        storage.set('token', accessToken);
        dispatch(toggleLoading('loginLoading'));
        return dispatch(getCurrentEmployee());
      }
      dispatch(toggleLoading('loginLoading'));
      return Promise.reject();
    } catch (error) {
      //
      dispatch(toggleLoading('loginLoading'));
      return Promise.reject();
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch(toggleLoading('logoutLoading'));
    try {
      const res = await LoginApi.fetchLogout();
      if (res.code === 0) {
        dispatch(toggleLoading('logoutLoading'));
        return Promise.resolve();
      }
      dispatch(toggleLoading('logoutLoading'));
      return Promise.reject();
    } catch (error) {
      //
      dispatch(toggleLoading('logoutLoading'));
      return Promise.reject();
    }
  };
};
